module.exports = __webpack_public_path__ + "static/img/book14.203e246.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/book14.jpg
// module id = /z2p
// module chunks = 1